import removeGlobalFormError from './helpers'

const formInput = document.querySelectorAll('.form-field-input')

function checkInputStatus(inputField, input, clearBtn) {

  const valueSize = input.value.length

  inputField.classList.remove('has-error')

  removeGlobalFormError(inputField)

  if(valueSize > 0) {
    inputField.classList.add('input-focus')
  } else {
    inputField.classList.remove('input-focus')
  }

  if(clearBtn) {
    if(valueSize > 0) {
      clearBtn.classList.remove('d-none')
    } else {
      clearBtn.classList.add('d-none')
    }
  }

}

formInput.forEach((inputField) => {

  const input = inputField.querySelector('input')
  const cleatBtn = inputField.querySelector('.input-clear')

  if(!input) return;

  input.addEventListener('focus', function () {
    inputField.classList.add('input-focus')
  })

  input.addEventListener('focusout', function () {
    checkInputStatus(inputField, input, cleatBtn)
  })

  input.addEventListener('keyup', () => {
    checkInputStatus(inputField, input, cleatBtn)
  })

  if(!cleatBtn) return;

  cleatBtn.addEventListener('click', function () {
    input.value = ''
    checkInputStatus(inputField, input, cleatBtn)
  })

})
